import React from 'react';

const ErrorLabel = (props) => {
    return (
        <span className="ms-2 small text-danger">
            {props.message != null ? props.message : ''}
        </span>
    )
}
export default ErrorLabel